import AppViewsCollection from '../collections/appViews';
import AppBodyView from '../views/appBodyView';

export const bodyViews = new AppViewsCollection([]);

export const bodyView = new AppBodyView({
	viewCollection: bodyViews,
});

export default bodyViews;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
if (process.env.NODE_ENV !== 'production') {
	setGlobal({bodyViews});
}
